import { Spin } from 'antd';
import Center from '../components/center';

const LXSpinner: React.FC = () => {
  return (
    <Center>
      <Spin size={'large'}></Spin>
    </Center>
  );
};

export default LXSpinner;
